import React from 'react';
import { Link } from 'react-router-dom';

export const FloatingSideButton = () => {
  return (
    <Link
      to="/contact"
      onClick={() => window.scrollTo(0, 0)}
      className="fixed left-0 top-1/2 -translate-y-1/2 z-40 bg-gradient-to-b from-teal-600 to-teal-700 text-white py-4 px-3 shadow-lg hover:from-teal-700 hover:to-teal-800 transition-all duration-300 hover:shadow-xl rounded-r-lg"
      style={{
        writingMode: 'vertical-rl',
        textOrientation: 'mixed',
      }}
    >
      <span className="text-sm font-semibold tracking-wide flex items-center gap-2">
        Discuss Your Projects
        <svg className="w-4 h-4 rotate-90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
        </svg>
      </span>
    </Link>
  );
};
